module.exports = __webpack_public_path__ + "static/favicon.e20bf7d1.ico";


//////////////////
// WEBPACK FOOTER
// ./src/pages/favicon.ico
// module id = 345
// module chunks = 213534597649335